import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/app/layouts/dashboard.vue").then(m => m.default || m))
}